import { render, staticRenderFns } from "./PositionCorrectionObjectLocator.vue?vue&type=template&id=056add5a&scoped=true&"
import script from "./PositionCorrectionObjectLocator.vue?vue&type=script&lang=ts&"
export * from "./PositionCorrectionObjectLocator.vue?vue&type=script&lang=ts&"
import style0 from "./PositionCorrectionObjectLocator.vue?vue&type=style&index=0&id=056add5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056add5a",
  null
  
)

export default component.exports